import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Clipboard = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M13.9407 4C14.381 2.49438 15.7988 1.5 17.4 1.5H22.6C24.2012 1.5 25.619 2.49438 26.0593 4H30.4C32.3938 4 34 5.62423 34 7.61538V32.3846C34 34.3758 32.3938 36 30.4 36H9.6C7.60622 36 6 34.3758 6 32.3846V7.61538C6 5.62423 7.60622 4 9.6 4H13.9407ZM13.8 6H9.6C8.7219 6 8 6.71766 8 7.61538V32.3846C8 33.2823 8.7219 34 9.6 34H30.4C31.2781 34 32 33.2823 32 32.3846V7.61538C32 6.71766 31.2781 6 30.4 6H26.2V6.38461C26.2 8.37577 24.5938 10 22.6 10H17.4C15.4062 10 13.8 8.37577 13.8 6.38461V6ZM17.4 3.5C16.4619 3.5 15.8 4.16077 15.8 5V6.38461C15.8 7.28234 16.5219 8 17.4 8H22.6C23.4781 8 24.2 7.28234 24.2 6.38461V5C24.2 4.16077 23.5381 3.5 22.6 3.5H17.4ZM12 16C12 15.4477 12.4477 15 13 15H22C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H13C12.4477 17 12 16.5523 12 16ZM12 22.9172C12.0033 22.3649 12.4536 21.9198 13.0059 21.9231L26.0059 22C26.5582 22.0033 27.0033 22.4536 27 23.0059C26.9967 23.5582 26.5464 24.0033 25.9941 24L12.9941 23.9231C12.4418 23.9198 11.9967 23.4694 12 22.9172Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Clipboard;
